import { fetchMtrByOriginalSerial } from '#/api/imsMgmt/settings/mtr/fetchByOriginalSerial';
import { mapMtrRowToAssemblyOption } from '#/modules/imsMgmt/settings/mtr/helper/assemblyOptionsSerialize';

export const ORIGINAL_SERIAL_SCAN_LABELS = {
  trigger: '掃原廠料號',
  title: '掃原廠料號加入物料',
  description: '掃描或輸入原廠料號，累加至下方清單後確認加入入庫明細。',
  inputLabel: '輸入原廠料號',
  inputTip: '可用掃碼機輸入。命中一筆會加入下方清單；若同一原廠對應多筆物料會再開視窗選一個。',
  confirm: '確認加入',
  scannedListTitle: '已掃描物料',
  emptyList: '尚未掃描物料，請輸入或掃入原廠料號。',
  notFound: '未找到對應原廠料號的物料',
  duplicate: '此物料已在掃描清單中，未重複加入',
  ambiguousTitle: '選擇物料',
  ambiguousDescription: (code) => (
    code
      ? `原廠料號「${code}」對應多筆物料，請單選一筆加入。`
      : '此原廠料號對應多筆物料，請單選一筆加入。'
  ),
  ambiguousConfirm: '加入',
};

export function mapOriginalSerialRowToScanItem(row) {
  const option = mapMtrRowToAssemblyOption(row);
  if (!option) {
    return null;
  }

  return {
    ...option,
    originalSerialList: Array.isArray(row?.originalSerialList)
      ? row.originalSerialList
      : [],
  };
}

export function getOriginalSerialItemId(item) {
  return item?.optionMtrId ?? item?.id ?? '';
}

export async function lookupOriginalSerial(code) {
  const result = await fetchMtrByOriginalSerial(code);
  const items = (Array.isArray(result?.data) ? result.data : [])
    .map(mapOriginalSerialRowToScanItem)
    .filter(Boolean);

  return { items };
}
